import { render, staticRenderFns } from "./Venue.vue?vue&type=template&id=0b2ee6f3"
import script from "./Venue.vue?vue&type=script&lang=ts"
export * from "./Venue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports